export default function StraightArrow(
  ctx,
  x1,
  y1,
  x2,
  y2,
  value,
  arrowColour,
  energyColour,
  timeIndex
) {
  // reverse flow
  if (value < 0) {
    let x = x1;
    let y = y1;
    x1 = x2;
    y1 = y2;
    x2 = x;
    y2 = y;
  }

  var dx = x2 - x1;
  var dy = y2 - y1;
  var rot = -Math.atan2(dx, dy);
  var len = Math.sqrt(dx * dx + dy * dy);

  var width = 20;
  var arrowHeadLen = width * 2;

  ctx.save();

  ctx.translate(x1, y1);
  ctx.rotate(rot);

  if (value === 0) {
    Line(ctx, len, width, "black", 0.05);
  } else {
    const gradient = ctx.createLinearGradient(0, -width, 0, len + width);

    let index1 = timeIndex / 2;
    gradient.addColorStop(Math.max(index1 - 0.1, 0), arrowColour);
    gradient.addColorStop(index1, energyColour);
    gradient.addColorStop(Math.min(index1 + 0.1, 1), arrowColour);

    let index2 = timeIndex / 2 + 0.5;
    gradient.addColorStop(Math.max(index2 - 0.1, 0), arrowColour);
    gradient.addColorStop(index2, energyColour);
    gradient.addColorStop(Math.min(index2 + 0.1, 1), arrowColour);

    ArrowHead(ctx, len, width, arrowHeadLen, gradient, 1.0);
    Line(ctx, len - arrowHeadLen, width, gradient, 1.0);
  }

  ctx.restore();
}

function Line(ctx, len, width, fillStyle, alpha) {
  ctx.save();
  let y = len - width * 0.6;
  ctx.beginPath();
  while (y >= 0) {
    ctx.moveTo(0, y);
    ctx.ellipse(0, y, width / 2, width / 2, 0, 0, 360);
    y -= width * 1.2;
  }
  ctx.fillStyle = fillStyle;
  ctx.globalAlpha = alpha;
  ctx.fill();
  ctx.restore();
}

function ArrowHead(ctx, y, width, arrowHeadLen, fillStyle, alpha) {
  ctx.save();
  ctx.beginPath();
  ctx.moveTo(0, y);
  ctx.lineTo(-width, y - arrowHeadLen);
  ctx.lineTo(width, y - arrowHeadLen);
  ctx.closePath();
  ctx.fillStyle = fillStyle;
  ctx.globalAlpha = alpha;
  ctx.fill();
  ctx.restore();
}
